import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';
import moment from 'moment';

export const reducerName = 'receptionState';

const initialState = {
    lastHostUpdate: null,
    settings: undefined,
    hosts: undefined,
    notificationError: undefined,
};

export const getSettings = createAsyncThunk(
    'receptionState/getSettings',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/reception/getSettings`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const getPersonsWithMeetings = createAsyncThunk(
    'receptionState/getPersonsWithMeetings',
    async (_, { getState, rejectWithValue }) => {
        try {
            const lastUpdate = getState().receptionState.lastHostUpdate;
            if (!lastUpdate || moment().add(-5, 'minutes').isAfter(moment(lastUpdate))) {
                const response = await axios({
                    method: 'GET',
                    url: `${config.server}/api/reception/GetPersonsWithMeetings`,
                    withCredentials: true,
                    auth: createAuth(getState),
                });
                return response.data;
            }
            return undefined;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const notifyPerson = createAsyncThunk(
    'receptionState/notifyPerson',
    async (personId, { getState, rejectWithValue }) => {
        try {
            await axios({
                method: 'GET',
                url: `${config.server}/api/reception/Notify/${personId}`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return true;
        } catch (error) {
            return rejectWithValue('notificationError');
        }
    }
);

const receptionSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        resetNotifyError: (state) => {
            state.notificationError = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSettings.fulfilled, (state, action) => {
                state.settings = action.payload;
            })
            .addCase(getPersonsWithMeetings.fulfilled, (state, action) => {
                if (action.payload) {
                    state.hosts = action.payload;
                    state.lastHostUpdate = moment().valueOf();
                }
            })
            .addCase(notifyPerson.rejected, (state, action) => {
                state.notificationError = true;
            })
            .addCase(notifyPerson.fulfilled, (state) => {
                state.notificationError = undefined;
            });
    },
});

export const { resetNotifyError } = receptionSlice.actions;

export default receptionSlice.reducer;